import React from 'react'

/**
 * Shared form-success checkmark — Asana 018 (2026-08-19), based on the
 * Appraisal thank-you page with the requested tweaks:
 *   • corner radius `sm` (2px) — was radius-lg
 *   • tick stroke 1px — was 2.5
 * Rendered above the "Thank you" heading on every form success state so all
 * thank-you screens read the same.
 */
export function ThankYouMark({ className }: { className?: string }) {
  return (
    <div
      className={`flex h-16 w-16 items-center justify-center rounded-sm bg-accent ${className || ''}`}
      aria-hidden="true"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="28"
        height="28"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="1"
        strokeLinecap="round"
        strokeLinejoin="round"
        className="text-foreground"
      >
        <polyline points="20 6 9 17 4 12" />
      </svg>
    </div>
  )
}
